export function initSiteShell() {
    const header = document.querySelector('[data-site-header]');
    const toggle = document.querySelector('[data-menu-toggle]');
    const menu = document.querySelector('[data-mobile-menu]');

    if (header) {
        const syncHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 12);
        syncHeader();
        window.addEventListener('scroll', syncHeader, { passive: true });
    }

    if (!toggle || !menu) return;

    const getFocusable = () => [toggle, ...menu.querySelectorAll('a[href]')];
    const setOpen = (isOpen, restoreFocus = false) => {
        menu.classList.toggle('is-open', isOpen);
        menu.setAttribute('aria-hidden', String(!isOpen));
        toggle.classList.toggle('is-open', isOpen);
        toggle.setAttribute('aria-expanded', String(isOpen));
        toggle.setAttribute('aria-label', isOpen ? 'メニューを閉じる' : 'メニューを開く');
        document.body.classList.toggle('menu-open', isOpen);

        if (isOpen) {
            menu.querySelector('a')?.focus();
        } else if (restoreFocus) {
            toggle.focus();
        }
    };

    toggle.addEventListener('click', () => setOpen(!menu.classList.contains('is-open')));
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setOpen(false)));

    document.addEventListener('keydown', (event) => {
        if (!menu.classList.contains('is-open')) return;
        if (event.key === 'Escape') {
            event.preventDefault();
            setOpen(false, true);
            return;
        }
        if (event.key !== 'Tab') return;

        const focusable = getFocusable();
        const currentIndex = focusable.indexOf(document.activeElement);
        if (currentIndex === -1) return;
        const nextIndex = event.shiftKey ? currentIndex - 1 : currentIndex + 1;
        if (nextIndex < 0 || nextIndex >= focusable.length) {
            event.preventDefault();
            focusable[(nextIndex + focusable.length) % focusable.length]?.focus();
        }
    });

    window.matchMedia('(min-width: 1001px)').addEventListener?.('change', (event) => {
        if (event.matches) setOpen(false);
    });
}

export function showToast(message) {
    const toast = document.querySelector('[data-toast]');
    if (!toast || !message) return;

    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(showToast.timeoutId);
    showToast.timeoutId = window.setTimeout(() => toast.classList.remove('is-visible'), 3200);
}
